import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {isUhcEnabled} from 'libs/rollout';
import {getPhones} from 'selectors/storeInfo';

import {useIsCartPage} from '../useIsCartPage/useIsCartPage';
import {useIsUhcPage} from '../useIsUhcPage/useIsUhcPage';

/**
 * Custom hook to get actual phone.
 * @returns {string} String value indicating an actual phone.
 */
export const useGetActualPhone = () => {
    const {isCartPage} = useIsCartPage();
    const {isUhcPage} = useIsUhcPage();
    const phones = useHostSelector(getPhones);

    return isUhcEnabled() || isUhcPage ? phones.uhc : (isCartPage && phones.cart) || phones.default;
};
